import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import PackAdjust from 'components/Sales/Smart/Prepack/pack/PackAdjust';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function SmartUnpackAdjust(): JSX.Element {
  return (
    <ContentLayout 
    titleKey="smart.prepack.pack.adjust.title" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
    // title={`Pick By SKU(Pick List)(W#: ${getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))})`}
    >
      <PackAdjust />
    </ContentLayout>
  );
}
